export const GET_NOTIFICATIONS = '/notifications'
export const READ_NOTIFICATION = '/notifications/:id'
export const RETRY_JOB = '/:serviceName/jobs/:correlationId/retries'
